CANDYRACK_DOCUMENT_LISTENER = true;

CANDYRACK_CAN_ATC = (btn) => {
  let url = window.location.href;
  url = new URL(url);
  const params = new URLSearchParams(url.search);

  const variant = params.get('variant');

  if (variant) {
    return true;
  }

  const form = document.querySelector('form[action="/cart/add"]');
  if (form) {
    return !form.querySelector('.select-container');
  }

  return false;
};